import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon-container" }

import {
  mdiDropbox,
  mdiFileExcelBox,
  mdiFilePdfBox,
  mdiFilePowerpointBox,
  mdiFileWordBox,
  mdiImage,
  mdiPaperclip,
  mdiTextBox,
  mdiVideoOutline,
  mdiYoutube
} from "@mdi/js";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileListItemIcon',
  props: {
  fileLocation: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;

const isImage = computed<boolean>(() => {
  return props.fileLocation.match(/\.(jpeg|jpg|gif|png|webp)$/) !== null;
});
const isPDF = computed<boolean>(() => {
  return props.fileLocation.match(/\.(pdf)$/) !== null;
});
const isVideo = computed<boolean>(() => {
  return props.fileLocation.match(/\.(wmv|mpeg|mpg|mov|avi|mp4|m4v)$/) !== null;
});
const isYouTubeVideo = computed<boolean>(() => {
  return (
    props.fileLocation.includes("youtube.com") ||
    props.fileLocation.includes("youtu.be")
  );
});
const isDropbox = computed<boolean>(() => {
  return props.fileLocation.includes("dropbox.com");
});
const isText = computed<boolean>(() => {
  return props.fileLocation.match(/\.(txt)$/) !== null;
});
const isDocument = computed<boolean>(() => {
  return (
    props.fileLocation.match(/\.(doc|docx|rtf)$/) !== null ||
    props.fileLocation.includes("docs.google.com/document/") ||
    props.fileLocation.includes("sharepoint.com/:w:/")
  );
});
const isSpreadsheet = computed<boolean>(() => {
  return (
    props.fileLocation.match(/\.(xls|xlsx|csv)$/) !== null ||
    props.fileLocation.includes("docs.google.com/spreadsheets/") ||
    props.fileLocation.includes("sharepoint.com/:x:/")
  );
});
const isPresentation = computed<boolean>(() => {
  return (
    props.fileLocation.match(/\.(ppt|pptx|ppsx|pps)$/) !== null ||
    props.fileLocation.includes("docs.google.com/presentation/") ||
    props.fileLocation.includes("sharepoint.com/:p:/")
  );
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (isDocument.value)
      ? (_openBlock(), _createBlock(_component_SVGIcon, {
          key: 0,
          path: _unref(mdiFileWordBox)
        }, null, 8, ["path"]))
      : (isSpreadsheet.value)
        ? (_openBlock(), _createBlock(_component_SVGIcon, {
            key: 1,
            path: _unref(mdiFileExcelBox)
          }, null, 8, ["path"]))
        : (isPresentation.value)
          ? (_openBlock(), _createBlock(_component_SVGIcon, {
              key: 2,
              path: _unref(mdiFilePowerpointBox)
            }, null, 8, ["path"]))
          : (isPDF.value)
            ? (_openBlock(), _createBlock(_component_SVGIcon, {
                key: 3,
                path: _unref(mdiFilePdfBox)
              }, null, 8, ["path"]))
            : (isImage.value)
              ? (_openBlock(), _createBlock(_component_SVGIcon, {
                  key: 4,
                  path: _unref(mdiImage)
                }, null, 8, ["path"]))
              : (isText.value)
                ? (_openBlock(), _createBlock(_component_SVGIcon, {
                    key: 5,
                    path: _unref(mdiTextBox)
                  }, null, 8, ["path"]))
                : (isVideo.value)
                  ? (_openBlock(), _createBlock(_component_SVGIcon, {
                      key: 6,
                      path: _unref(mdiVideoOutline)
                    }, null, 8, ["path"]))
                  : (isYouTubeVideo.value)
                    ? (_openBlock(), _createBlock(_component_SVGIcon, {
                        key: 7,
                        path: _unref(mdiYoutube)
                      }, null, 8, ["path"]))
                    : (isDropbox.value)
                      ? (_openBlock(), _createBlock(_component_SVGIcon, {
                          key: 8,
                          path: _unref(mdiDropbox)
                        }, null, 8, ["path"]))
                      : (_openBlock(), _createBlock(_component_SVGIcon, {
                          key: 9,
                          path: _unref(mdiPaperclip)
                        }, null, 8, ["path"]))
  ]))
}
}

})